function mergeOptions (options = {}) {
  return {
    required: options.required ?? true
  }
}

function parse (value, options) {
  let parsedValue

  const mergedOptions = mergeOptions(options)

  try {
    parsedValue = JSON.parse(value)
  } catch (error) {
    parsedValue = typeof value === 'string' ? value : undefined
  }

  if (mergedOptions.required && parsedValue == null) {
    throw new Error('Value is required!')
  }

  return parsedValue
}

export function number (value, options) {
  const parsedValue = parse(value, options)

  if (typeof parsedValue !== 'number') {
    throw new Error(`"${value}" is not a valid number!`)
  }

  return parsedValue
}

export function boolean (value, options) {
  const parsedValue = parse(value, options)

  if (typeof parsedValue !== 'boolean') {
    throw new Error(`"${value}" is not a valid boolean!`)
  }

  return parsedValue
}

export function json (value, options) {
  try {
    return parse(value, options)
  } catch (e) {
    throw new Error(`"${value}" is not a valid json!`)
  }
}

export function string (value, options) {
  const mergedOptions = mergeOptions(options)
  const parsedValue = parse(value, mergedOptions)

  if (typeof parsedValue !== 'string') {
    throw new Error(`"${value}" is not a valid string!`)
  }

  if (mergedOptions.required && value.trim() === '') {
    throw new Error('Value is required!')
  }

  return parsedValue
}
